/**
 * @fileoverview gRPC-Web generated client stub for wisetime.user.cues.v4
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: wisetime/user/cues/v4/user_cues.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';
import * as wisetime_user_cues_v4_user_cues_pb from '../../../../wisetime/user/cues/v4/user_cues_pb';


export class UserCuesServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorListUserCues = new grpcWeb.MethodDescriptor(
    '/wisetime.user.cues.v4.UserCuesService/ListUserCues',
    grpcWeb.MethodType.UNARY,
    wisetime_user_cues_v4_user_cues_pb.ListUserCuesRequest,
    wisetime_user_cues_v4_user_cues_pb.ListUserCuesResponse,
    (request: wisetime_user_cues_v4_user_cues_pb.ListUserCuesRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_cues_v4_user_cues_pb.ListUserCuesResponse.deserializeBinary
  );

  listUserCues(
    request: wisetime_user_cues_v4_user_cues_pb.ListUserCuesRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_cues_v4_user_cues_pb.ListUserCuesResponse>;

  listUserCues(
    request: wisetime_user_cues_v4_user_cues_pb.ListUserCuesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_cues_v4_user_cues_pb.ListUserCuesResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_cues_v4_user_cues_pb.ListUserCuesResponse>;

  listUserCues(
    request: wisetime_user_cues_v4_user_cues_pb.ListUserCuesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_cues_v4_user_cues_pb.ListUserCuesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.cues.v4.UserCuesService/ListUserCues',
        request,
        metadata || {},
        this.methodDescriptorListUserCues,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.cues.v4.UserCuesService/ListUserCues',
    request,
    metadata || {},
    this.methodDescriptorListUserCues);
  }

  methodDescriptorCreateUserCue = new grpcWeb.MethodDescriptor(
    '/wisetime.user.cues.v4.UserCuesService/CreateUserCue',
    grpcWeb.MethodType.UNARY,
    wisetime_user_cues_v4_user_cues_pb.CreateUserCueRequest,
    wisetime_user_cues_v4_user_cues_pb.UserCue,
    (request: wisetime_user_cues_v4_user_cues_pb.CreateUserCueRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_cues_v4_user_cues_pb.UserCue.deserializeBinary
  );

  createUserCue(
    request: wisetime_user_cues_v4_user_cues_pb.CreateUserCueRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_cues_v4_user_cues_pb.UserCue>;

  createUserCue(
    request: wisetime_user_cues_v4_user_cues_pb.CreateUserCueRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_cues_v4_user_cues_pb.UserCue) => void): grpcWeb.ClientReadableStream<wisetime_user_cues_v4_user_cues_pb.UserCue>;

  createUserCue(
    request: wisetime_user_cues_v4_user_cues_pb.CreateUserCueRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_cues_v4_user_cues_pb.UserCue) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.cues.v4.UserCuesService/CreateUserCue',
        request,
        metadata || {},
        this.methodDescriptorCreateUserCue,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.cues.v4.UserCuesService/CreateUserCue',
    request,
    metadata || {},
    this.methodDescriptorCreateUserCue);
  }

  methodDescriptorDeleteUserCue = new grpcWeb.MethodDescriptor(
    '/wisetime.user.cues.v4.UserCuesService/DeleteUserCue',
    grpcWeb.MethodType.UNARY,
    wisetime_user_cues_v4_user_cues_pb.DeleteUserCueRequest,
    google_protobuf_empty_pb.Empty,
    (request: wisetime_user_cues_v4_user_cues_pb.DeleteUserCueRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteUserCue(
    request: wisetime_user_cues_v4_user_cues_pb.DeleteUserCueRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteUserCue(
    request: wisetime_user_cues_v4_user_cues_pb.DeleteUserCueRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteUserCue(
    request: wisetime_user_cues_v4_user_cues_pb.DeleteUserCueRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.cues.v4.UserCuesService/DeleteUserCue',
        request,
        metadata || {},
        this.methodDescriptorDeleteUserCue,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.cues.v4.UserCuesService/DeleteUserCue',
    request,
    metadata || {},
    this.methodDescriptorDeleteUserCue);
  }

}

